<h1>{{ "Avslutt avtale"|translate }}</h1>
@if(erNil(avtaleSomSignal())){
<!--  for å slippe NPE -->
} @else if (avtaleSomSignal()!.avtalestatus == Avtalestatus.terminert) {
  <inline-melding type="advarsel" class="e2e-avtale-terminert">{{ 'Avslutningen er fullført. Alle data slettes {slettesDato}.'|translate:{slettesDato: avtaleSomSignal()!.slettesDato|zoneddatetimeSomPlaindate|plaindate} }}
  </inline-melding>
} @else if (avtaleIProvePeriode()) {
  <inline-melding type="info">
    {{ 'Avtalen kan ikke avsluttes i prøveperioden. Prøveperioden utløper {utloepsdato}.'|translate:{utloepsdato: avtaleSomSignal()!.proeveperiodeUtloepsdato|zoneddatetimeSomPlaindate|plaindate} }}
  </inline-melding>
} @else if (erProvePeriodeUtloept()) {
  <inline-melding type="advarsel">
    {{ 'Avtalens prøveperiode har utløpt. Alle data slettes {slettesDato}.'|translate:{slettesDato: avtaleSomSignal()!.slettesDato|zoneddatetimeSomPlaindate|plaindate} }}
  </inline-melding>
} @else if (!kanBrukerTerminereAvtale()) {
  <div class="ikke-tilgang">
  <inline-melding type="info">
    {{
      'Det er kun avtalens kontaktperson ({epost}) som kan avslutte avtalen ({navn}).' |translate: {
        epost: avtaleSomSignal()!.kontaktperson.epost,
        navn: avtaleSomSignal()!.navn
      }
    }}
  </inline-melding>
  </div>
} @else {
  <div class="last-ned">
    <div class="forklaring">
      <div>
        {{ 'For å avslutte avtalen må du først laste ned dine data, åpne den nedlastede filen (.zip) og hente en bekreftelseskode som du registrerer på denne siden. Koden bekrefter at filen inneholder alle dine data.'|translate }}
        {{ 'OBS: Nedlastningen kan ta noen minutter.'|translate }}
      </div>
      <div class="grupper">
        {{ 'Følgende grupper inngår i nedlastningen:'|translate }}
        <ul>
          @for (gruppe of avtaleSomSignal()!.grupper; track gruppe.id) {
            <li>{{ gruppe.organisasjonsnavn }} - {{ gruppe.tittel }}</li>
          }
        </ul>
      </div>
      @if (kanAvtaleTermineresInfo().status === KanTermineresStatus.NEDLASTING_FOR_GAMMEL) {
        <inline-melding type="advarsel" class="nedlasting-for-gammel" data-testid="nedlasting-for-gammel">
          {{ 'Koden for nedlastingen {nedlastetTidspunkt} har utløpt. Du må laste ned data pả nytt for å avslutte avtalen.'|translate: {nedlastetTidspunkt: zipNedlastetTidspunkt()|zoneddatetime} }}
        </inline-melding>
      }
    </div>
    <div class="knapp">
      <a mat-button mat-raised-button color="primary" (click)="lastNedKlikket()" class="e2e-last-ned-avtale"
         href="{{url()}}" download="{{filnavn()}}">
        <mat-icon>download</mat-icon>
        {{ "Last ned data" | translate }}</a>
    </div>
  </div>
  <hr>
  <div class="bekreft" [ngClass]="{'grayout': !kanAvtaleAvsluttes()}">
    <!-- ingen [formGroup] da siden kun inneholder én formControl -->
    <form (ngSubmit)="terminer()">
      <div class="forklaring">
        <h2>{{ 'Hvordan finne bekreftelseskoden?'|translate }}</h2>
        {{ 'Åpne filen du lastet ned ({filnavn}). Se etter filen bekreftelseskode.txt. Åpne dokumentet og skriv inn koden i feltet lenger ned på denne siden.'|translate:{filnavn: filnavn()} }}
      </div>
      <div>
        {{
          ' Avtalen avsluttes og alle data slettes om {dager} dager, den {slettesDato}'|translate:{
            dager: kanAvtaleTermineresInfo().antallDagerFoerSletting,
            slettesDato: kanAvtaleTermineresInfo().beregnetSlettedato |zoneddatetimeSomPlaindate|plaindate
          }
        }}
      </div>
      <inline-melding type="info" data-testid="kode-varighet">
        {{ 'Koden er gyldig til {tidspunkt}.'|translate: {tidspunkt: kanAvtaleTermineresInfo().maaAvsluttesFoer|zoneddatetime} }}
      </inline-melding>
      <div class="otp-label">{{ 'Skriv inn bekreftelseskoden du lastet ned '|translate }}
        <span class=fet>{{ zipNedlastetTidspunkt()|zoneddatetime }}</span>
      </div>
      <div class="otp">
        <div class="kode">
          <otp-felt [formControl]="otpKodeSkjema" [ugyldig]="otpValideringFeilet()"></otp-felt>
        </div>
        <div class="knapp">
          <button type="submit" mat-raised-button color="primary"
                  [disabled]="otpKodeSkjema.disabled || otpKodeSkjema.invalid || lagrer()">
            {{ 'Avslutt avtale'|translate }}
          </button>
        </div>
      </div>
    </form>
    <div class="hjelp">
      <h2>{{ 'Finner du ikke bekreftelseskoden?'|translate }}</h2>
      <div [innerHTML]="'Ta kontakt med oss på tlf <a href=tel:+4740604475>406 04 475</a>, eller send oss en mail på <a href=mailto:post@styreplan.no>post@styreplan.no</a>' | translate"></div>
    </div>
  </div>
}

